import { Form } from "react-bootstrap";

const Notes = ({ values, handleChange, touched, errors }) => {
    return (
        <>
            <Form.Group>
                <Form.Label>Notes</Form.Label>
                <Form.Control
                    name="notes"
                    as="textarea"
                    placeholder="Add any relevant details or observations here."
                    value={values.notes}
                    onChange={handleChange}
                />
            </Form.Group>
        </>
    )
}

export default Notes;